import * as React from 'react';
import { loadTheme } from '@fluentui/style-utilities';
import { CoherenceTheme } from '@coherence-design-system/styles';


export function CoherenceThemeProvider(props: React.PropsWithChildren<unknown>): React.ReactNode {
  loadTheme(CoherenceTheme);

  return props.children;
}
